"use client";

import styled from "styled-components";

export const Box = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 1rem;
    gap: 0.75rem;
  }
`;

export const Title = styled.h3`
  color: var(--colorTitle);
  font-family: "Inter Bold";
  font-size: 20px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const FirstBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const Description = styled.p`
  font-family: "Inter Medium";
  color: var(--textLight);
  font-size: 14px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
